module.exports = __webpack_public_path__ + "static/media/open-menu-icon.f7ee8c4a.svg";